import React, { useEffect, useState } from 'react';
import {Line} from 'react-chartjs-2';
import {API_URL} from "./App";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend
);

const LineChart = () => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    fetch(API_URL + '/statistics/chart-data')
      .then((res) => res.json())
      .then((data) => {
        setChartData({
          labels: data.labels,
          datasets: data.datasets
        });
      });
  }, []);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Die Schuldenfalle',
        font: {
          size: 20,
          weight: 'bold',
        },
      },
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 20,
            weight: 'bold',
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: '#c2aecf25',          // dunkle Farbe
          lineWidth: 2            // fetter
        },
        ticks: {
          font: {
            size: 18,
            weight: 'bold',
          },
        },
      },
      y: {
        grid: {
          color: '#c2aecf25',          // dunkle Farbe
          lineWidth: 2            // fetter
        },
        beginAtZero: true,
        ticks: {
          font: {
            size: 18,
            weight: 'bold',
          },
        },
      },
    },
  };

  return chartData ?<div>
    <h2>Punkteverteilung der Spieler </h2>
    <Line data={chartData} options={options} />
  </div> : <p>Loading chart...</p>;
};

export default LineChart;